import React, {useRef} from 'react';
import {useMutation} from '@tanstack/react-query';
import {PopupConfirm, PopupConfirmHandle} from '../../_layout/popups/PopupConfirm';
import {Chat} from '../../../types/chat';
import {confirmByResponsible, requestConfirmation} from '../../../services/chats';
import {useAlert} from "../../../context/alert";

interface Props {
    claim_pk: string
    onRequested: Function
}

export const ConfirmByResponsible = ({claim_pk, onRequested}: Props) => {
    const alertRef = useRef<PopupConfirmHandle>(null);
    const {setInfo} = useAlert();
    const {mutate: complete, isPending} = useMutation({
        mutationFn: confirmByResponsible,
        onSuccess: (data) => {
            onRequested();
            setInfo('Запрос на подтверждение заявки направлен');
        }
    });

    const submit = () => {
        complete(claim_pk);
    }

    return (
        <>
            <PopupConfirm
                header='Запросить подтверждение?'
                submitBtnText='Запросить'
                onSubmit={submit}
                isPending={isPending}
                ref={alertRef}
            />
            <button
                className='bg-melon-yellow my-0 px-4 py-3 rounded-lg'
                onClick={() => alertRef?.current?.togglePopup()}
            >
                <div className='my-auto'>
                    Запросить подтверждение
                </div>
            </button>
        </>
    );
};
